import React from "react";
import { RouteObject } from "react-router-dom";
import withSuspense from "../../components/wrappers/WithSuspense";

const InternalCourse = React.lazy(() => import("./index"));
const CourseList = React.lazy(() => import("./pages/CourseList"));
const CreateDraft = React.lazy(() => import("./pages/CreateCourse"));
const Course = React.lazy(() => import("./pages/EditCourse"));

export const internalCourseRoutes: RouteObject[] = [
  {
    path: "",
    element: withSuspense(InternalCourse),
    children: [
      {
        path: "",
        index: true,
        element: withSuspense(CourseList),
      },
      {
        path: "create",
        element: withSuspense(CreateDraft),
      },
      {
        path: "modules/:courseId",
        element: withSuspense(Course),
      },
    ],
  },
];
